/** Адреса одного значения: по одному на строку (так пишут хранимки и правила). */
export const splitLinkAddresses = (value?: string): string[] =>
    (value ?? '')
        .split(/\r?\n/)
        .map((address) => address.trim())
        .filter(Boolean);
